export const TabContainer = "TabContainer";
export const TabContainerBoxed = `${TabContainer}--boxed`;
